import API from '@/services/api'

export default async function getNearPointInARange(position) {
  if (!position?.lat || !position?.lng) return []
  const response = await API.post('points/near', {
    lat: position.lat, //'-22.978759',
    lng: position.lng, //'-43.230361',
    range: 500
  })
  return response.data
}
